var _style, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKlaytn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "CIRCLE_OUTLINE_BLACK",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BD072F;}\n\t.st1{fill:#FA4212;}\n\t.st2{fill:#FF8000;}\n\t.st3{fill:#B70C02;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254.8,288.1c53.9,53.8,107,106.8,160,159.7c-87.9,75.2-225.9,78.4-319.7-1.2 C148.5,393.7,201.7,340.9,254.8,288.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M291.5,255.9c35.2-36.2,70.9-73.2,107-109.9c15-15.3,30.5-29.9,46.1-44.6c1.2-1.1,5.2-1.3,5.9-0.4 c27.4,36,47.8,75.3,53.2,120.8c8.2,69.4-7.7,132.6-51.3,188.1c-1.2,1.5-2.3,3.2-2.9,4.1C396.3,360.7,343.1,307.6,291.5,255.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M139.1,337.8c5.9-15.6,11.9-31.2,17.8-46.8c24.5-64.5,49-129,73.5-193.4c7.7-20,16.4-39.7,24.3-59.7 c3-7.7,5.3-15.7,7.7-23.6c1.8-5.9,5.4-8.1,11.6-7.5c24.4,2.4,48.4,6.2,70.9,16.5c13,6,26.3,11.4,38.7,18.5 c10.1,5.8,18.9,13.7,30.1,22L140.7,339L139.1,337.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M200.2,47.7c-45.9,121.5-91.7,242.9-138.5,366.9c-8.8-13.4-17-24.7-23.9-36.7c-15.8-27.5-25.9-57.9-29.9-89.4 c-1.9-15-1.5-30.4-1.6-45.6c0-2.4,2.2-5.3,4.1-7.2C69.5,176.4,128.8,117.3,188,58.2c3.6-3.6,7.1-7.4,10.7-11.2L200.2,47.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlaytn);
export default __webpack_public_path__ + "static/media/klaytn.5c570c72fc1acba8b9c7bf49e4b838c0.svg";
export { ForwardRef as ReactComponent };